import Constants from "expo-constants";
import { Platform } from "react-native";

const { expoConfig } = Constants;
export const isStaging = false;
// export const isDev = process.env.NODE_ENV === "development" || isStaging;
export const stagingBaseUrl = "https://staging-partners.memorang.app";
export const isDev = false;

export const baseNextjsUrl = isDev
	? Platform.OS === "android"
		? `http://${expoConfig!.hostUri?.split(":").shift()}:3000`
		: isStaging
			? "https://hub.memorang.com"
			: "http://localhost:3000"
	: "https://hub.memorang.com";

export const baseDevUrl =
	Platform.OS === "android"
		? `http://${expoConfig!.hostUri?.split(":").shift()}:8081`
		: isStaging
			? "https://staging-partners.memorang.app"
			: "http://localhost:8081";

export const ENDPOINT_GET_WAVEFORM_DATA = `${baseNextjsUrl}/api/ai/get-audio-waveform`;

export const ENDPOINT_TTS = `${baseNextjsUrl}/api/ai/tts`;
